export const observeScrolledPast = (
	target: Element,
	callback: (isScrolledPast: boolean) => void,
	rootMargin?: string
): void => {
	const observer = new IntersectionObserver(
		(entries) => {
			const entry = entries[0]
			callback(!entry.isIntersecting && entry.boundingClientRect.top < 0)
		},
		{ threshold: 0, rootMargin }
	)

	observer.observe(target)
}
